export const transformNotificationTypes = notificationTypes => {
  return (
    notificationTypes?.map(notificationType => ({
      ...notificationType,
      cc_emails: notificationType?.cc_emails || [],
    })) || []
  )
}
